import axios from 'axios';
import API from '../config/API';

function _authHeaders() {
    // The v2 auth middleware reads the custom 'accessToken' header
    // (req.get('accessToken')) — NOT the Authorization bearer.
    return {
        'Content-Type': 'application/json',
        'accessToken': localStorage.getItem('accessToken') || '',
    };
}

function listPendingForSalonClient(salonClientId) {
    return axios.get(API.PENDING_CLIENT_UPDATES_FOR_SALON_CLIENT + salonClientId, { headers: _authHeaders() });
}

function listPendingByClientUserId(clientUserId) {
    return axios.get(API.PENDING_CLIENT_UPDATES_BY_CLIENT + clientUserId, { headers: _authHeaders() });
}

function listPendingForMe() {
    return axios.get(API.PENDING_CLIENT_UPDATES_FOR_ME, { headers: _authHeaders() });
}

function acceptPending(id, body = {}) {
    return axios.post(API.PENDING_CLIENT_UPDATE_ACCEPT + id + '/accept', body, { headers: _authHeaders() });
}

function dismissPending(id) {
    return axios.post(API.PENDING_CLIENT_UPDATE_DISMISS + id + '/dismiss', {}, { headers: _authHeaders() });
}

function previewMerge(body) {
    return axios.post(API.USER_MERGE_PREVIEW, body, { headers: _authHeaders() });
}

function confirmMerge(body) {
    return axios.post(API.USER_MERGE_CONFIRM, body, { headers: _authHeaders() });
}

function rollbackMerge(mergeId) {
    return axios.post(API.USER_MERGE_ROLLBACK + mergeId + '/rollback', {}, { headers: _authHeaders() });
}

export const clientSyncService = {
    listPendingForSalonClient,
    listPendingByClientUserId,
    listPendingForMe,
    acceptPending,
    dismissPending,
    previewMerge,
    confirmMerge,
    rollbackMerge
};
